import i18n from '@/i18n';
import Vue from 'vue';
import iziToast from 'izitoast';
import {
  getWhiteLabel,
  startListenerQueue,
  getDateTime,
  getSystemFile,
} from '@/services/system-service';
import {
  SET_VALIDATOR,
  ADD_NOTIFICATION,
  REMOVE_NOTIFICATION,
  SET_DISPLAY_USER_CONFIGURATIONS,
  RESET_SYSTEM,
  SET_SERVER_TIME,
  SET_SHOW_DASHBOARD,
  SET_QUEUE_LISTENER_MESSAGE_BROKER,
  UPDATE_PAUSE_ALERTS,
  ADD_ALERT_NOT_READ,
  CLEAN_ALERT_NOT_READ,
  SET_SYSTEM_FILE,
  SET_MENU_SELECTED,
  SET_WHITELABEL,
} from '@/store/mutation-types';
import { notify } from '@/shared/utils/browser-notify';

const actions = {
  setValidator({ commit }, validator) {
    commit(SET_VALIDATOR, validator);
  },

  showSnackbar({ commit }, options) {
    const title = i18n.t(`types_alert.${options.type}`);
    const body = i18n.t(`${options.text}`, options.replaces);
    const notification = {
      type: options.type,
      body: body || options.text,
      title: title || i18n.t('types_alert.notification'),
      time: new Date(),
    };

    console.log('Notification: ', body);

    const toastOptions = {
      message: Vue.filter('capitalize')(notification.body),
      theme: 'dark',
      messageColor: 'white',
      class: options.type == 'error' ? 'error' : 'notification-info',
      progressBarColor: 'white',
      position: 'bottomLeft',
      timeout: notification.body.length > 35 ? 10000 : 5000,
    };

    iziToast.show(toastOptions);
    commit(ADD_NOTIFICATION, notification);

    if (options.browserNotify) notify(notification);
  },

  removeNotification({ commit }, id) {
    commit(REMOVE_NOTIFICATION, id);
  },

  resetState({ dispatch, commit }) {
    dispatch('attendance/reset');
    dispatch('channel/reset');
    dispatch('jobs/reset');
    dispatch('whatsappCampaigns/reset');
    dispatch('chatVisor/reset');
    dispatch('pause/clear');
    dispatch('fastJob/reset');
    dispatch('contact/reset');
    commit(RESET_SYSTEM);
  },

  setDisplayUserConfigurations({ commit }, display) {
    commit(SET_DISPLAY_USER_CONFIGURATIONS, display);
  },

  getServerTime({ commit }) {
    return getDateTime()
      .then((serverDate) => {
        serverDate.browserTime = new Date();
        commit(SET_SERVER_TIME, serverDate);
        return true;
      })
      .catch((error) => {
        return false;
      });
  },

  setShowDashboard({ commit }, handle) {
    commit(SET_SHOW_DASHBOARD, handle);
  },

  updateQueueToListenMessageBroker({ commit }, { queueToListen, agentId }) {
    const params = {
      agentId,
      queue: queueToListen,
    };
    return startListenerQueue(params).then(() => {
      commit(SET_QUEUE_LISTENER_MESSAGE_BROKER, queueToListen);
    });
  },

  addPausaAlert({ commit }, params) {
    commit(UPDATE_PAUSE_ALERTS, params);
  },

  addAlertNotRead({ commit }) {
    commit(ADD_ALERT_NOT_READ);
  },

  cleanAlertNotRead({ commit }) {
    commit(CLEAN_ALERT_NOT_READ);
  },

  async setSystemfile({ commit }) {
    await getSystemFile().then((info) => {
      commit(SET_SYSTEM_FILE, info);
    });
  },
  addNotification({ commit }, information) {
    const notification = {
      type: information.eventType,
      body: information.message,
      title: information.title,
      time: new Date(),
    };

    commit(ADD_NOTIFICATION, notification);
  },
  setCurrentNavigationMenu({ commit }, menuSelected) {
    commit(SET_MENU_SELECTED, menuSelected);
  },
  async getWhiteLabelTheme({ commit }) {
    try {
      const { data } = await getWhiteLabel();
      commit(SET_WHITELABEL, data);
    } catch (error) {
      console.error(error);
    }
  },
};

export default actions;
